module.exports = __webpack_public_path__ + "static/auto-layout-c9b65e376e2dc75792325d3591d9d701.gif";